import { DISMISS_FEEDBACK, FEEDBACK_FAILED, FEEDBACK_REQUESTED, OPEN_SLIDE_PANEL, SET_FEEDBACK_MODAL, SET_SLIDE_STATUS, SET_SLIDE_URL, TOGGLE_SLIDE_PANEL } from './actionTypes';
export function toggleSlidePanel() {
    return {
        type: TOGGLE_SLIDE_PANEL
    };
}
export function setSlideUrl(url, kind = 'slide', score) {
    return {
        type: SET_SLIDE_URL,
        url,
        kind,
        score
    };
}
export function setSlideStatus(status) {
    return {
        type: SET_SLIDE_STATUS,
        status
    };
}
/**
 * スライドパネルを必ず表示する（既に開いていれば何もしない）。
 *
 * @returns {Object}
 */
export function openSlidePanel() {
    return {
        type: OPEN_SLIDE_PANEL
    };
}
/**
 * 会話評価を依頼した。進行ポップアップを出し、ボタンを「作成中」にする。
 *
 * @returns {Object}
 */
export function feedbackRequested() {
    return {
        type: FEEDBACK_REQUESTED
    };
}
/**
 * 会話評価が失敗した。
 *
 * @param {string} error - 利用者に見せる理由。
 * @returns {Object}
 */
export function feedbackFailed(error) {
    return {
        type: FEEDBACK_FAILED,
        error
    };
}
/**
 * 進行ポップアップの表示/非表示。
 *
 * @param {boolean} visible - 表示するか。
 * @returns {Object}
 */
export function setFeedbackModal(visible) {
    return {
        type: SET_FEEDBACK_MODAL,
        visible
    };
}
/**
 * 会話評価の表示を終える。
 *
 * @returns {Object}
 */
export function dismissFeedback() {
    return {
        type: DISMISS_FEEDBACK
    };
}
